import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

interface SelectorProp {
    labelText: string;
    label?: string;
    width?: number | string | object;
    disabled?: boolean;
}

export default function BasicSelect({ labelText, label, width, disabled }: SelectorProp) {
    const [age, setAge] = React.useState('');

    const handleChange = (event: SelectChangeEvent) => {
        setAge(event.target.value as string);
    };

    console.log('my label value is', label);

    return (
        <Box sx={{ minWidth: 120, width: width, height: 52, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            <FormControl fullWidth disabled={disabled}>
                <InputLabel sx={{ fontSize: { xs: 10, sm: 15 } }} id="demo-simple-select-label">
                    {label}
                </InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    sx={{ width: width, height: 25, p: 3 }}
                    label={label}
                    onChange={handleChange}
                >
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
}
